export const TIME_SELECTOR_DATE_CHANGED = 'TIME_SELECTOR_DATE_CHANGED';
export const BENCHMARK_CONFIGURATION = 'BENCHMARK_CONFIGURATION';